__turbopack_context__.v({
  "form": "Form-module-scss-module__pJvLWq__form",
  "form_control": "Form-module-scss-module__pJvLWq__form_control",
  "form_group": "Form-module-scss-module__pJvLWq__form_group",
});
